import { Trash2 } from 'lucide-react';
import { Button } from '../ui/button';

interface DiscountRemoveButtonProps {
  onRemove: () => void;
  className?: string;
}

export function DiscountRemoveButton({ onRemove, className }: DiscountRemoveButtonProps) {
  return (
    <Button
      onClick={onRemove}
      variant="ghost"
      size="icon"
      className={className}
      aria-label="Remove discount"
    >
      <Trash2 className="h-3.5 w-3.5" />
    </Button>
  );
}
